import { Form } from "react-bootstrap";
import { useRef, useState, useEffect } from "react";
import { Styles } from "./styles";
import { useTranslation } from "react-i18next";
import { SlCalender } from "react-icons/sl";
import { InputTypes } from "../../../../constants/enums";

const CustomDate = ({
  fieldItem,
  value,
  onChange,
  errorMessage,
  validateOnChange,
  type
}) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const { name, placeHolder, width, className, borderColor } = fieldItem;

  const selectedDate = value;
  const inputRef = useRef(null);
  const [showYearPicker, setShowYearPicker] = useState(false);

  const handleClick = () => {
    if (type === InputTypes.year) {
      setShowYearPicker(!showYearPicker);
    } else {
      inputRef.current?.showPicker?.();
    }
  };

  const handleYearSelect = (year) => {
    onChange(`${year}-01-01`);
    setShowYearPicker(false);
  };

  const displayValue = () => {
    if (type === InputTypes.year && selectedDate) {
      return selectedDate.split('-')[0];
    }
    return selectedDate;
  };

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= 1900; year--) {
      years.push(year);
    }
    return years;
  };

  // Close year picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showYearPicker && !event.target.closest('.year-picker') && !event.target.closest('.date-placeholder')) {
        setShowYearPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showYearPicker]);

  return (
    <Styles
      errorMessage={errorMessage}
      validateOnChange={validateOnChange}
      width={width}
      isAr={isAr}
      className={className}
      borderColor={borderColor}
    >
      <Form.Label className="date-placeholder" onClick={handleClick}>
        <span className="icon">
          <SlCalender />
        </span>
        <span>{displayValue() || placeHolder}</span>
      </Form.Label>

      <Form.Control
        type={type === InputTypes.year ? "hidden" : "date"}
        className="input"
        name={name}
        placeholder={placeHolder}
        value={selectedDate}
        onChange={(e) => onChange(e.target.value)}
        ref={inputRef}
      />

      {type === InputTypes.year && showYearPicker && (
        <div className="year-picker">
          <div className="year-picker-content">
            {generateYears().map((year) => (
              <div
                key={year}
                className={`year-option ${displayValue() === year.toString() ? 'selected' : ''}`}
                onClick={() => handleYearSelect(year)}
              >
                {year}
              </div>
            ))}
          </div>
        </div>
      )}
    </Styles>
  );
};

export default CustomDate;
